module.exports = __webpack_public_path__ + "img/person.1507f7d2.svg";